<template>
  <!-- 店铺 -->
  <BjDialogList
    ref="dialogStoresList"
    :config="shopOnlineDefault"
    row-keys="code"
    @confirm="dialogListConfirm"
  />
</template>
<script>
import { channelApi } from '@/api';
export default {
  data() {
    return {
      shopOnlineDefault: {
        title: this.$t('ExternalPlatformProducts.confirm.store'),
        columns: [
          {
            prop: 'code',
            label: this.$t('ExternalPlatformProducts.confirm.Encoding'),
          },
          {
            prop: 'name',
            label: this.$t('ExternalPlatformProducts.confirm.Name'),
          },
          {
            prop: 'channelTypeMeaning',
            label: this.$t('ExternalPlatformProducts.confirm.Sales'),
          },
          {
            prop: 'onlineStoreTypeMeaning',
            label: this.$t('ExternalPlatformProducts.confirm.Type'),
          },
          {
            prop: 'authStatus',
            label: this.$t('ExternalPlatformProducts.confirm.status'),
            constantKey: 'CHANNEL_ONLINE_CREDIT_STATUS',
          },
        ],
        search: [
          {
            placeholder: this.$t('ExternalPlatformProducts.confirm.enter'),
            key: 'code',
          },
          {
            placeholder: this.$t('ExternalPlatformProducts.confirm.Please'),
            key: 'name',
          },

          {
            placeholder: this.$t('ExternalPlatformProducts.confirm.select'),
            key: 'channelTypeCode',
            component: 'BjSelectLov',
            lovCode: 'SCHL.CHANNEL_TYPE',
          },
        ],
        actionApi: channelApi.getOnlineShopPage,
      },
    };
  },
  methods: {
    show(data) {
      this.$refs.dialogStoresList.show(data);
    },
    dialogListConfirm(data) {
      this.$emit('confirm', data);
    },
  },
};
</script>
